module.exports = __webpack_public_path__ + "img/bg-section-09-mobile.c6dad0a1.svg";